(function() {
  'use strict';

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-upsell-btn]');
    if (!btn) return;
    e.preventDefault();

    var lineKey = btn.dataset.lineKey;
    var quantity = parseInt(btn.dataset.quantity, 10) || 1;

    var properties = {};
    try { properties = JSON.parse(btn.dataset.itemProperties || '{}'); } catch (err) {}

    var options = [];
    try { options = JSON.parse(btn.dataset.frameOptions || '[]'); } catch (err) {}
    if (!options.length) return;

    var modal = document.querySelector('frame-option-selector-modal');
    if (modal && typeof modal.open === 'function') {
      modal.open(options, lineKey, properties, quantity);
    }
  });

  // Normalize line-item properties back into a clean { key: value } object.
  // Mirrors size-selector-modal.js: guards against the {"0":"key,value"} array
  // shape TeeInBlue can produce, so customization props survive the re-add.
  function normalizeProperties(properties) {
    if (!properties) return {};
    var normalized = {};

    if (Array.isArray(properties)) {
      properties.forEach(function(item) {
        if (Array.isArray(item) && item.length >= 2) normalized[String(item[0])] = String(item[1]);
      });
      return normalized;
    }

    Object.keys(properties).forEach(function(key) {
      var value = properties[key];
      if (/^\d+$/.test(key) && typeof value === 'string' && value.indexOf(',') !== -1) {
        var commaIdx = value.indexOf(',');
        normalized[value.substring(0, commaIdx).trim()] = value.substring(commaIdx + 1).trim();
      } else {
        normalized[key] = value;
      }
    });
    return normalized;
  }

  // Re-render the cart drawer / notification using the theme's proven path.
  function refreshCart() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
    }

    var drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return Promise.resolve();

    var sectionIds = drawer.getSectionsToRender().map(function(s) { return s.id; });
    return fetch('/cart.js?sections=' + sectionIds.join(','))
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }
      })
      .catch(function() { location.reload(); });
  }

  function resetButton(btn) {
    if (!btn) return;
    btn.disabled = false;
    btn.classList.remove('is-loading');
    var lbl = btn.querySelector('.cart-upsell-btn__label');
    if (lbl) lbl.textContent = btn.dataset.originalText || 'Voeg een lijst toe aan je poster';
  }

  // Swap the paper-poster line for the chosen framed variant.
  // ADD FIRST, then remove the paper line — so a failed add never empties the cart.
  window.performUpsell = function(lineKey, newVariantId, properties, quantity) {
    var qty = parseInt(quantity, 10) || 1;
    var props = normalizeProperties(properties);
    var btn = document.querySelector('[data-upsell-btn][data-line-key="' + lineKey + '"]');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      var label = btn.querySelector('.cart-upsell-btn__label');
      if (label) label.textContent = btn.dataset.loadingText || 'Lijst toevoegen…';
    }

    // 1) Add the framed variant first.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(newVariantId, 10), quantity: qty, properties: props })
    })
      .then(function(res) {
        if (!res.ok) {
          return res.json().catch(function() { return {}; }).then(function(body) {
            console.error('Frame add failed:', res.status, body);
            throw new Error('add-failed');
          });
        }
        // 2) Only after a successful add, remove the paper line.
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        }).then(function(r) { return r.json(); });
      })
      .then(function() { return refreshCart(); })
      .catch(function(err) {
        console.error('Frame upsell failed:', err);
        resetButton(btn);
      });
  };
})();
